import React from "react";

import {Helmet} from "react-helmet";

import {EventOrigin} from "@globals/config/eventUtils";
import {IMAGE_SIZES} from "@globals/functions/getResolutionImgUrl";
import {useUser} from "@globals/user";

import DishDetails, {DishDetailsConfigProvider} from "@components/DishDetails";
import LoadingDots from "@components/LoadingDots";
import Footer from "@components/layout/Footer";
import MaxWidthContainer from "@components/layout/MaxWidthContainer";

import useDishDetails from "./hooks/useDishDetails";
import styles from "./index.scss";
import formatError from "./utils/formatError";

export default function DishApp(): JSX.Element {
  const {isAuthorized} = useUser();
  const {dish, isLoading, isError, error} = useDishDetails();

  return (
    <>
      <div className={styles.container}>
        <MaxWidthContainer tagName="main">
          {isLoading && <LoadingDots />}
          {!isLoading && isError && <>{formatError(error!)}</>}
          {!isLoading && !isError && dish && (
            <>
              <Helmet>
                <title>
                  {dish.item} - {dish.restaurant.name} - EAT Club
                </title>
                <meta
                  name="description"
                  content={`${dish.item} from ${dish.restaurant.name} - ${dish.description}`}
                />
                <link
                  rel="canonical"
                  href={`https://www.eatclub.com/dish/${dish.operator_slug}/${dish.slug}`}
                />
              </Helmet>
              <DishDetailsConfigProvider
                hidePrice
                showFavoriteHoverBox
                showFavorites={isAuthorized}
                hidePurchaseButton
              >
                <DishDetails
                  dish={dish}
                  imageSize={IMAGE_SIZES.DISH_PAGE}
                  eventOrigin={EventOrigin.PAGE}
                />
              </DishDetailsConfigProvider>
            </>
          )}
        </MaxWidthContainer>
      </div>
      <Footer />
    </>
  );
}
